@if(tableRows.length > 1) {
    <p-table
        #dt
        class="ngTable table-response"
        [columns]="tableColumns"
        [value]="tableRows"
        [paginator]="true"
        responsiveLayout="scroll"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 25, 50]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [tableStyle]="{ 'min-width': '50rem' }"
        [globalFilterFields]="globalFilterFields"
        [paginatorDropdownAppendTo]="'body'"
    >
        <ng-template pTemplate="caption">
            <div class="flex justify-content-end align-items-center">
                <div class="flex align-items-center gap-2">
                    <p-iconfield iconPosition="left">
                        <p-inputicon>
                            <i class="pi pi-search"></i>
                        </p-inputicon>
                        <input
                            pInputText
                            type="text"
                            (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="Search table"
                        />
                    </p-iconfield>
                    <p-button
                        icon="pi pi-download"
                        (onClick)="dt.exportCSV()"
                        [rounded]="true"
                        [outlined]="true"
                        severity="secondary"
                        pTooltip="Export"
                    />
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th 
                    *ngFor="let col of columns"
                    [pSortableColumn]="col.sortField || col.field"
                    scope="col"
                >
                    <div class="flex align-items-center gap-2">
                        {{ col.header }}
                        <p-sortIcon [field]="col.sortField || col.field" />
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{ rowData[col.field] }}
                </td>
            </tr>
        </ng-template>
    </p-table>
}
